import { useEffect, useState } from 'react';
import { formatTime } from '../../../../../core/commom/formatTime';
import { Button } from '../../../../../core/components/atoms/Button';
import { Icon } from '../../../../../core/components/atoms/Icon';
import {
  Tag,
  TagProps,
  TagVariant,
} from '../../../../../core/components/atoms/Tag';
import { Typography } from '../../../../../core/components/molecules/Typography';

interface LessonCardItemProps {
  content: any;
  selected?: boolean;
  onClick?: () => void;
  onClickDone?: (contentId: string) => void;
}

function LessonCardItem({
  content,
  selected,
  onClick,
  onClickDone,
}: LessonCardItemProps) {
  const [isLoadingDone, setIsLoadingDone] = useState(false);

  const teacher = content.target.teacher[0];
  const incidence =
    `incidencia${content.incidence}` as keyof TagProps['variant'];

  useEffect(() => {
    setIsLoadingDone(false);
  }, [content.done]);

  return (
    <div
      className={`flex flex-col gap-sm rounded-md bg-color-lightest p-4 shadow-level-2 hover:cursor-pointer ${
        selected ? 'border-hairline border-brand-color-primary-pure' : ''
      }`}
      onClick={onClick}
      id={content._contentId}
    >
      <header className='flex items-center gap-sm'>
        <Icon
          Icon={'play_circle'}
          type='material'
          className='text-lg text-brand-color-secondary-pure'
        />
        <Typography type='titleSection' size='h6' className='w-full'>
          videoaula
        </Typography>

        <Button
          iconId={`check-icon-${content.done ? 'done' : 'unseen'}`}
          variant='text'
          onlyIcon
          LeftIcon={'check_circle'}
          loading={isLoadingDone}
          disabled={content.done}
          classNameIcon={`${
            content.done
              ? 'text-feedback-color-success-pure'
              : 'text-mono-color-medium'
          } text-lg filled`}
          className='p-0'
          onClick={(e) => {
            e.stopPropagation();
            onClickDone && onClickDone(content._contentId);
            setIsLoadingDone(true);
          }}
        />
      </header>
      <main>
        <Typography type='title' size='h4' className='line-clamp-2'>
          {content.target.title}
        </Typography>
      </main>
      <footer className='text-mono-800 flex items-center gap-sm'>
        <Typography size='small'>
          {formatTime(content.target.duration)}
        </Typography>

        {teacher && <Typography size='small'>Prof. {teacher.name}</Typography>}

        {content.incidence > 0 && (
          <Tag variant={incidence as TagProps['variant']}>{`Incidência ${content.incidence}`}</Tag>
        )}
      </footer>
    </div>
  );
}

export { LessonCardItem };
